import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const {
    testimonials
  } = pageData;
  return <section className="py-24 px-4 bg-navy-900 border-y border-white/5" data-id="element-191">
      <div className="max-w-5xl mx-auto" data-id="element-192">
        <h2 className="text-3xl md:text-4xl text-center mb-16" data-id="element-193">
          {testimonials.heading}
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-194">
          {testimonials.items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-slate-850 border border-slate-800 rounded-2xl p-8 relative" data-id="element-195">
              <div className="text-6xl text-slate-800 font-serif absolute top-4 right-6 leading-none" data-id="element-196">
                "
              </div>

              <div className="flex text-gold-500 mb-6" data-id="element-197">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-198" />)}
              </div>

              <p className="text-lg text-slate-300 leading-relaxed mb-8 relative z-10 italic" data-id="element-199">
                "{item.quote}"
              </p>

              <div data-id="element-200">
                <div className="font-bold text-white text-lg" data-id="element-201">{item.name}</div>
                <div className="text-slate-500 text-sm" data-id="element-202">{item.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}